import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
type ToggleInputDataType = {
  key: string;
  label: string;
};
interface ToggleInputInterface {
  buttonsData: ToggleInputDataType[];
  setChoosenInput: Dispatch<SetStateAction<string>>;
  choosenInput: string;
}
interface ButtonInterface {
  buttoninfo: ToggleInputDataType;
  setChoosenInput: Dispatch<SetStateAction<string>>;
  choosenInput: string;
}
const Button = ({
  buttoninfo,
  choosenInput,
  setChoosenInput
}: ButtonInterface) => {
  return (
    <button
      onClick={() => {
        setChoosenInput(buttoninfo.key);
      }}
      className={choosenInput == buttoninfo.key ? 'selected' : ''}
      data-cy={`toggle-${buttoninfo.key}`}
    >
      {buttoninfo.label}
    </button>
  );
};

const ToggleInput = ({
  buttonsData,
  setChoosenInput,
  choosenInput
}: ToggleInputInterface) => {
  return (
    <Container>
      {buttonsData?.map((butt: ToggleInputDataType) => (
        <Button
          buttoninfo={butt}
          choosenInput={choosenInput}
          setChoosenInput={setChoosenInput}
          key={butt.key}
        />
      ))}
    </Container>
  );
};
const Container = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.light.borderColors.primary};
  background-color: transparent;
  button {
    width: 100%;
    height: 100%;
    border: none;
    padding: 5px 8px;
    text-align: center;
    font-family: materialRegular;
    font-size: ${props => props.theme.font.sizes.s};
    color: ${props => props.theme.light.colors.darkGrey};
    background-color: transparent;
  }

  .selected {
    color: ${props => props.theme.light.colors.black};
    border-bottom: 1px solid #000000;
  }
  @media screen and (max-width: ${props =>
      props.theme.breakPoints.tablet.max}) {
    button {
      padding: 14px 0px;
    }
  }
`;
export default ToggleInput;
